import { useEffect, useState } from "react";
import type { StaffProfile } from "@ferrivia/api-contract";
import { useApi } from "@ferrivia/auth-web";

export type StaffProfileState =
  | { status: "loading" }
  | { status: "error" }
  | { status: "success"; profile: StaffProfile };

export function useStaffProfile(): StaffProfileState {
  const api = useApi();
  const [state, setState] = useState<StaffProfileState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    api.clinicStaff
      .staffMe()
      .then((profile) => {
        if (!cancelled) {
          setState({ status: "success", profile });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({ status: "error" });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [api]);

  return state;
}
